import { connect } from 'react-redux';
import AulaEditor from './AulaEditor';
import {
  API_URL,
  FILE_URL,
} from '../../../../../../../../core/constants/endpoints';
import { getFileScanStatus } from '../../../../../../../../core/selectors/fileScan';

let lastConfig = null;

const mapStateToProps = (state) => {
  const filesUrl = FILE_URL();
  const apiUrl = API_URL();

  if (
    !lastConfig ||
    lastConfig.filesUrl !== filesUrl ||
    lastConfig.apiUrl !== apiUrl
  ) {
    lastConfig = { filesUrl, apiUrl };
  }

  return {
    config: lastConfig,
    fileScanStatus: getFileScanStatus(state),
  };
};

export default connect(mapStateToProps)(AulaEditor);
